export function useRequest<T extends any[], U>(
  request: (...args: T) => Promise<U>,
  options = { loading: false }
) {
  const loading = ref(options.loading)
  const fn = async (...args: T): Promise<U> => {
    loading.value = true
    let res = await request(...args)
    loading.value = false
    return res
  }
  return [fn, loading] as const
}
